import { Box, Typography } from "@mui/material";
import React from "react";

function TitleIcon({ title, icon }) {
  return (
    <Box
      mb={5}
      display="flex"
      flexDirection="row"
      alignItems="center"
      sx={{ color: "text.textPropProject" }}
    >
      {icon}
      <Typography
        component="h1"
        variant="h4"
        sx={{ color: "primary.main", fontWeight: "normal", ml: 1 }}
      >
        {title}
      </Typography>
    </Box>
  );
}

export default TitleIcon;
